import { useForm } from 'react-hook-form';
import { useGetClaimEdit } from './useGetClaimEdit';
import { useEffect, useMemo, useState } from 'preact/hooks';
import { useOptionZipcode } from './useOptionZipcode';
import { useZipcode } from './useZipcodeQuery';
import { useEditClaimData } from './useEditClaimData';
import { UpdateClaimEdit } from '../../../../resources/payload';
import { breakdownSubsQuery } from '../../../../services/react-query/optionMasterQuery';

export const useGetClaimEditList = () => {
  const { control, setValue, getValues, reset, watch, handleSubmit } = useForm();
  const [state, setState] = useState();
  const [timelineList, setTimelineList] = useState();
  const [claimData, setClaimData] = useState();
  const [claimEditData, setClaimEditData] = useState();
  const [breakdownList, setBreakdownList] = useState();
  const queryParams = new URLSearchParams(window.location.search);
  const claimCode = queryParams.get('code');
  const breakdownId = watch('breakdownId');
  const productTypeCode = watch('productTypeCode');

  const breakdownSubsProductType = useMemo(() => {
    const id = breakdownId === '' || breakdownId === undefined ? null : breakdownId;
    if (!id || !breakdownList?.length) {
      return productTypeCode ?? null;
    }
    return breakdownList.find((item) => item.value === id)?.productType ?? productTypeCode ?? null;
  }, [breakdownId, breakdownList, productTypeCode]);

  const { mutate: onCallZipCode, loading: isLoadingZipCode } = useZipcode({ reset, getValues });
  const { data: breakdownSubsOptions, isLoading: isLoadingBreakdownSubs } = breakdownSubsQuery({
    productType: breakdownSubsProductType,
  });

  const { dataSource, loading: isLoadingClaimEdit } = useGetClaimEdit({
    claimCode: state?.claimCode,
    reset,
    getValues,
    setValue,
  });

  const { mutate: onEditClaim, loading: isLoadingToEdit } = useEditClaimData();
  const { provinceOptions, districtOptions, subDistrictOptions } = useOptionZipcode({
    watch,
  });

  const onEnterZipcode = (value) => {
    onCallZipCode(value, {
      onSuccess: (result) => {
        reset({
          ...getValues(),
          ...result,
          provinceId: '',
          districtId: '',
          subDistrictId: '',
          other: '',
        });
      },
    });
  };

  const updateTimeline = () => {
    if (claimEditData?.timelineList) {
      const timeline = claimEditData.timelineList.map((item) => ({
        text: item?.optionStatusNameTh,
        color: item?.optionStatusCode === claimEditData?.claim.claimStatus ? 'green' : 'black',
      }));
      setTimelineList(timeline);
    }
  };

  const onSubmit = () =>
    handleSubmit((values) => {
      const formData = UpdateClaimEdit(values);
      onEditClaim(formData);
    })();

  useEffect(() => {
    claimCode && setState({ claimCode });
    dataSource && setClaimEditData(dataSource);
    if (claimEditData) {
      setClaimData(claimEditData?.claim);
      if (claimData?.remainingDays > 300000) {
        setValue('remainingDays', 'ตลอดชีวิต');
      }
      updateTimeline(claimEditData);
    }

    const autoCallZipCode = (values) => {
      if (values) {
        onCallZipCode(values);
      }
    };

    autoCallZipCode(claimEditData?.claim?.zipCode);
    const breakdown =
      claimEditData?.breakdowns?.map((item) => ({
        label: item?.breakdownNameTh,
        value: item?.breakdownId,
        productType: item?.productType,
      })) ?? [];

    setBreakdownList(breakdown);
  }, [claimCode, dataSource, claimEditData, setValue, claimData]);

  const onChangeBreakdown = (value, item) => {
    switch (item?.name) {
      case 'breakdownId':
        setValue('breakdownSubId', '');
        break;
      default:
        break;
    }
  };

  return {
    control,
    setValue,
    getValues,
    reset,
    timelineList,
    watch,
    provinceOptions,
    districtOptions,
    subDistrictOptions,
    breakdownSubsOptions,
    isLoadingClaimEdit,
    onEnterZipcode,
    breakdownList,
    isLoadingZipCode,
    onSubmit,
    isLoadingToEdit,
    isLoadingBreakdownSubs,
    onChangeBreakdown,
  };
};
